import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import getScrollTop from '../util/getScrollTop';
import Ripple from './Ripple.jsx';
import Loader from './Loader';

const mapStateToProps = state => ({
  windowWidth: state.events.windowSize.width,
});

/**
  * VButton implements buttons with ripple as specified in the style guide and supports the types:
  * ['primary', 'facebook', 'green', 'whiteblue']
  */

@connect(mapStateToProps)
export default class VButton extends React.PureComponent {
  constructor() {
    super();
    this.instance = null;
    this.state = {
      ripple: false,
      rel: {
        x: 0,
        y: 0,
      },
    };
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.windowWidth === this.props.windowWidth;
  }

  handleActionStart(evt) {
    if (evt.button) return;

    let elementOffsetY = 0;
    let elementOffsetX = 0;
    if (this.instance) {
      // Need to calculate offset each time, because page layout may be changed since mount
      const boundRectange = this.instance.getBoundingClientRect();
      elementOffsetY = (boundRectange.top + getScrollTop()).toFixed(0);
      elementOffsetX = boundRectange.left.toFixed(0);
    }

    // For some reason evt is not accessible in callback. So we do it like this.
    const { pageX, pageY } = evt;

    // Reset to handle repeated clicks.
    this.setState({ ripple: false }, () => {
      // Timeout needed to remove and then add class
      // See https://css-tricks.com/restart-css-animation/
      setTimeout(() => {
        this.setState({
          ripple: true,
          rel: {
            x: pageX - elementOffsetX,
            y: pageY - elementOffsetY,
          },
        });
      });
    });
  }

  render() {
    return (
      <this.props.elementType
        className={cx('vs-button', `vs-button-${this.props.type}`, {
          'vs-button-small': this.props.small,
        }, this.props.className)}
        ref={instance => {
          this.instance = instance;
        }}
        disabled={this.props.disabled}
        onClick={this.props.onClick}
        onMouseDown={evt => this.handleActionStart(evt)}
        onTouchStart={evt => this.handleActionStart(evt)}>
        {this.props.disabled &&
          <Loader size="22" className="btn-disabled-loader" />}
        <Ripple
          x={this.state.rel.x}
          y={this.state.rel.y}
          type={this.props.type}
          className={cx({ 'is-visible': this.state.ripple })}
        />
        {!this.props.disabled &&
          <span className="vs-button-text">{this.props.children}</span>}
      </this.props.elementType>
    );
  }
}

VButton.defaultProps = {
  elementType: 'button',
};

VButton.propTypes = {
  type: React.PropTypes.string.isRequired,
  small: React.PropTypes.bool,
  windowWidth: React.PropTypes.number,
  children: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.array,
    React.PropTypes.element,
  ]),
  className: React.PropTypes.string,
  onClick: React.PropTypes.func,
  disabled: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/component/VButton.jsx